import { render } from "./SendAccountEmail.vue?vue&type=template&id=5e4c22e5"
import script from "./SendAccountEmail.vue?vue&type=script&lang=js"
export * from "./SendAccountEmail.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__